import React from 'react';

export interface TooltipProps {
    content: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    /** Set when a trigger points at this bubble with aria-describedby. */
    id?: string;
}

/**
 * Lightweight CSS hover tooltip. Wrap any element; the bubble appears above on hover.
 *
 * `w-max` is load-bearing. The bubble is absolutely positioned, so without an
 * explicit width it shrink-to-fits against its CONTAINING BLOCK -- the wrapper
 * span -- not against its own text. On a narrow trigger (a button in a grid card)
 * that squeezed every tooltip down to the trigger's width, wrapping short phrases
 * over four or five lines and making `max-w-xs` below dead code. Sizing to
 * max-content and letting max-w-xs do the capping is what that class always meant.
 */
export const Tooltip: React.FunctionComponent<TooltipProps> = ({ content, children, className, id }) => {
    return (
        <span className={`group relative inline-flex items-center ${className ?? ''}`}>
            {children}
            <span
                id={id}
                role="tooltip"
                className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1 w-max max-w-xs -translate-x-1/2 rounded-md bg-zinc-900 px-2 py-1 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100 dark:bg-zinc-700"
            >
                {content}
            </span>
        </span>
    );
};
